<div fxLayout="column" class="access-container" fxLayoutAlign="start center">
    <mat-icon class="locker">lock</mat-icon>
    <div class="mg-1rem">
        <span class="access-title">{{msg.accessDeniedMsg.title}}</span>
    </div>
    <div fxFlex="50" class="text-align-center subTitle">
        <span>{{msg.accessDeniedMsg.content}}</span>
    </div>
</div>